document.addEventListener("DOMContentLoaded", () => {
  const slides = document.querySelectorAll(".slide");
  const sliders = document.querySelectorAll(".slider");
  const answerCircles = document.querySelectorAll(".answer-circle");
  const startQuiz = document.getElementById("start-quiz");
  const forwardButtons = document.querySelectorAll(".btn-next");
  const backButtons = document.querySelectorAll(".btn-prev");
  const questions = document.querySelectorAll(".question");
  const coins = document.querySelectorAll(".coin");

  /** @type {Record<string, string>} */
  const scoreFieldNameLookup = {
    "Operational Maturity Quiz": "opsMaturityQuizScore",
    "Automation Maturity Quiz": "automationMaturityQuizScore",
  };

  let currentSlideIndex = 0;
  /** @type {Record<number, number>} */
  const scores = {}; // Object to store scores for each slide

  // Function to show the current slide
  /**
   * @param {number} index
   */
  function showSlide(index) {
    const form = document.getElementById("mkto-api-form");
    slides.forEach((slide, i) => {
      slide.classList.toggle("active", i === index);
    });

    if (questions.length + 1 === index) {
      coins.forEach((coin) => {
        const delay = Math.random() * 1000; // Calculate random delay
        setTimeout(() => {
          coin.classList.add("coin-animation");
        }, delay); // Use the calculated delay
      });
      const answerString = buildAnswerString();
      const totalScore = getTotalScore();
      const programName = /** @type {HTMLInputElement} */ (
        document.querySelector('input[name="programName"]')
      )?.value;
      attachHiddenFieldToForm(
        form,
        scoreFieldNameLookup[programName] ?? "",
        totalScore.toString(),
      );
      attachHiddenFieldToForm(form, "Marketo_Lead_Comments__c", answerString);
      const followUpUrl = /** @type {HTMLInputElement} */ (
        form?.querySelector('input[name="follow_up_url"]')
      )?.value;
      if (followUpUrl) {
        attachHiddenFieldToForm(
          form,
          "follow_up_url",
          followUpUrl + "?score=" + totalScore,
        );
      }
    }
  }

  /**
   * @param {HTMLElement | null} form
   * @param {string} name
   * @param {string} value
   */
  function attachHiddenFieldToForm(form, name, value) {
    const field = /** @type {HTMLInputElement} */ (
      form?.querySelector(`input[name="${name}"]`)
    );
    if (field) {
      field.value = value;
      return;
    }

    const hiddenField = document.createElement("input");
    hiddenField.type = "hidden";
    hiddenField.name = name;
    hiddenField.value = value;
    form?.appendChild(hiddenField);
  }

  function getTotalScore() {
    return Object.values(scores).reduce((acc, score) => acc + score, 0);
  }

  // Function to handle score selection
  /**
   * @param {Event} event
   */
  function handleScoreSelection(event) {
    const target = /** @type {HTMLElement} */ (event.target);
    const score = target?.dataset["score"];
    const answerBar = getAnswerBar(currentSlideIndex);
    if (score) {
      scores[currentSlideIndex] = parseInt(score, 10);
      // Save the score for the current slide
      showScore(answerBar, currentSlideIndex);
    }

    const nextButton = /** @type {HTMLButtonElement} */ (
      getNextButton(currentSlideIndex)
    );
    if (nextButton) {
      const innerHTML = nextButton.innerHTML;
      nextButton.innerHTML = "Advancing...";
      setTimeout(() => {
        nextButton.click();
        nextButton.innerHTML = innerHTML;
      }, 500);
    }
  }

  /**
   * @param {{ target: any; }} event
   */
  function handleSliderChange(event) {
    const slider = event.target;
    const score = Math.ceil(slider.value / 10);
    const answerBar = getAnswerBar(currentSlideIndex);
    if (score) {
      scores[currentSlideIndex] = score; // Save the score for the current slide
      showScore(answerBar, currentSlideIndex);
    }
  }

  /**
   * @param {HTMLElement | undefined} HTMLElement
   */
  function getText(HTMLElement) {
    return HTMLElement?.innerText;
  }

  function buildAnswerString() {
    return Object.keys(scores)
      .map((key) => {
        const question = /** @type {HTMLElement} */ (
          questions[Number(key) - 1]
        );
        return `${getText(question)}: ${scores[Number(key)]}; `;
      })
      .join("\n");
  }

  /**
   * @param {HTMLElement | null} answerBar
   * @param {number} index
   */
  function showScore(answerBar, index) {
    const slideScore = scores[index];
    if (slideScore) {
      if (answerBar) {
        answerBar.querySelectorAll(".answer-circle").forEach((circle, idx) => {
          if (idx < slideScore) {
            circle.classList.add("score-active");
          } else {
            circle.classList.remove("score-active");
          }
        });
      }
    }

    disableButtons(index);
  }

  // Event listeners for forward buttons
  forwardButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const answerBar = getAnswerBar(currentSlideIndex + 1);
      if (currentSlideIndex < slides.length - 1) {
        currentSlideIndex++;
        showSlide(currentSlideIndex);
      }
      showScore(answerBar, currentSlideIndex);
    });
  });

  // Event listeners for back buttons
  backButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const answerBar = getAnswerBar(currentSlideIndex - 1);
      if (currentSlideIndex > 0) {
        currentSlideIndex--;
        showSlide(currentSlideIndex);
      }
      showScore(answerBar, currentSlideIndex);
    });
  });

  /**
   * @param {{ target: any; }} event
   */
  function handleAnswerMouseOver(event) {
    const btn = event.target;
    const score = btn.dataset.score;
    const answerBar = btn.parentElement;

    const answerCircles = answerBar.querySelectorAll(".answer-circle");
    answerCircles.forEach(
      (
        /** @type {{ classList: { add: (arg0: string) => void; }; }} */ circle,
        /** @type {number} */ idx,
      ) => {
        if (idx < score) {
          circle.classList.add("score-hover");
        }
      },
    );
  }

  /**
   * @param {{ target: any; }} event
   */
  function handleAnswerMouseOut(event) {
    const btn = event.target;
    const answerBar = btn.parentElement;

    const answerCircles = answerBar.querySelectorAll(".answer-circle");
    answerCircles.forEach(
      (
        /** @type {{ classList: { remove: (arg0: string) => void; }; }} */ circle,
      ) => {
        circle.classList.remove("score-hover");
      },
    );
  }

  /**
   * @param {number} index
   */
  function disableButtons(index) {
    const nextButton = /** @type {HTMLButtonElement} */ (getNextButton(index));
    if (!nextButton) {
      return;
    }

    if (scores[index]) {
      nextButton.disabled = false;
    } else {
      nextButton.disabled = true;
    }
  }

  /**
   * @param {number} index
   */
  function getAnswerBar(index) {
    return document.getElementById(`answer-bar-${index}`);
  }
  // function getSlider(index) {
  //   return document.getElementById(`score-slider-${index}`);
  // }

  // function getPrevButton(index) {
  //   const answerBar = getAnswerBar(index);
  //   return answerBar?.parentElement?.parentElement?.querySelector(".btn-prev") ?? null;
  // }

  /**
   * @param {number} index
   */
  function getNextButton(index) {
    const answerBar = getAnswerBar(index);
    return (
      answerBar?.parentElement?.parentElement?.querySelector(".btn-next") ??
      null
    );
  }

  // Event listener for Start Button
  if (startQuiz) {
    startQuiz.addEventListener("click", () => {
      currentSlideIndex = 1; // Move to the first question slide
      showSlide(currentSlideIndex);
      showScore(getAnswerBar(1), currentSlideIndex);
    });
  }

  // Event listener for progress circles
  answerCircles.forEach((circle) => {
    if (!circle) {
      return;
    }
    circle.addEventListener("click", handleScoreSelection);

    // add hover effect listerners
    circle.addEventListener("mouseover", handleAnswerMouseOver);
    circle.addEventListener("mouseout", handleAnswerMouseOut);
  });

  // Event listener for sliders
  sliders.forEach((slider) => {
    // Listen for the 'input' event (fires as the slider is dragged)
    slider.addEventListener("input", handleSliderChange);

    // Listen for the 'change' event (fires when the slider is released)
    // slider.addEventListener('change', handleSliderChange);
  });

  // Initialize the first slide
  showSlide(currentSlideIndex);
});
